// AI
export * from './src/queries-mutations/shared/ai/useQueryGetAIIProductPhotosList'
export * from './src/queries-mutations/shared/ai/useMutationClassifyInsurable'

// Business categories
export * from './src/queries-mutations/shared/business_categories/useQueryGetBusinessCategories'

// Docuseal
export * from './src/queries-mutations/shared/docuseal/useMutationCreateDocumentTemplateFromPdf'

// Users
export * from './src/queries-mutations/shared/users/useMutationChangeMainIdentity'
export * from './src/queries-mutations/shared/users/useMutationCreateUserAddress'
export * from './src/queries-mutations/shared/users/useMutationDeleteUserAddress'
export * from './src/queries-mutations/shared/users/useMutationDeleteUserIdentity'
export * from './src/queries-mutations/shared/users/useMutationForgotIdentityPassword'
export * from './src/queries-mutations/shared/users/useMutationGenerateContract'
export * from './src/queries-mutations/shared/users/useMutationGenerateQuote'
export * from './src/queries-mutations/shared/users/useMutationGenerateProforma'
export * from './src/queries-mutations/shared/users/useMutationGetDocumentUploadUrl'
export * from './src/queries-mutations/shared/users/useMutationLinkGoogleCalendar'
export * from './src/queries-mutations/shared/users/useMutationResendEmailVerification'
export * from './src/queries-mutations/shared/users/useMutationSyncUserIdentities'
export * from './src/queries-mutations/shared/users/useMutationUnlinkGoogleCalendar'
export * from './src/queries-mutations/shared/users/useMutationUpdateUserAddress'
export * from './src/queries-mutations/shared/users/useMutationUpdateUserBookingsSettings'
export * from './src/queries-mutations/shared/users/useMutationUpdateUserIdentity'
export * from './src/queries-mutations/shared/users/useMutationUpdateUserLogged'
export * from './src/queries-mutations/shared/users/useMutationUpdateUserTaxProfile'
export * from './src/queries-mutations/shared/users/useQueryGetAllIdentities'
export * from './src/queries-mutations/shared/users/useQueryGetContractPreview'
export * from './src/queries-mutations/shared/users/useQueryGetQuotePreview'
export * from './src/queries-mutations/shared/users/useQueryGetUserAddressById'
export * from './src/queries-mutations/shared/users/useQueryGetUserAddresses'
export * from './src/queries-mutations/shared/users/useQueryGetUserBookingsSettings'
export * from './src/queries-mutations/shared/users/useQueryGetUserLogged'
export * from './src/queries-mutations/shared/users/useQueryGetUserSubscription'
export * from './src/queries-mutations/shared/users/useQueryGetUserTaxProfile'
export * from './src/queries-mutations/shared/users/useMutationSetupOnboarding'
